import table from './table'

const people =
{
    ...table,
    helmet :
    {
        title : 'Personnes' ,
        metas : []
    },
    empty  : 'Aucune personne trouvée',
    search : 'Rechercher une personne ...' ,
    title  : 'Personnes'
};

export default people ;
